<template>
  <div>
    <Breadcrumb />
    <el-card class="box-card mt-20">
      <div slot="header" class="clearfix">
        <span>添加售后服务人员</span>
      </div>
      <el-form
        ref="salesPersonForm"
        :model="salePersonInfo"
        :rules="rules"
        class="add-form"
        :label-position="labelPosition"
        label-width="140px"
      >
        <div class="add-form-item">
          <el-form-item label="区域：" prop="productTypeId">
            <el-select
              v-model="salePersonInfo.productTypeId"
              clearable
              placeholder="请选择区域"
            >
              <el-option
                v-for="item in productTypeOptions"
                :key="item.productTypeId"
                :label="item.typeName"
                :value="item.productTypeId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="add-form-item">
          <el-form-item label="登录名：" prop="loginName">
            <el-input v-model="salePersonInfo.loginName"></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 最多输入25个字符</span>
        </div>
        <div class="add-form-item">
          <el-form-item label="登录密码：" prop="loginPwd">
            <el-input
              v-model="salePersonInfo.loginPwd"
              type="password"
            ></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 最多输入25个字符</span>
        </div>
        <div class="add-form-item">
          <el-form-item label="姓名：" prop="realName">
            <el-input v-model="salePersonInfo.realName"></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 最多输入25个字符</span>
        </div>
        <div class="add-form-item">
          <el-form-item label="工号：" prop="staffCode">
            <el-input v-model="salePersonInfo.staffCode"></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 最多输入25个字符</span>
        </div>
        <div class="add-form-item">
          <el-form-item label="联系电话：" prop="linkPhone">
            <el-input v-model="salePersonInfo.linkPhone"></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 最多输入25个字符</span>
        </div>
        <br />
        <el-form-item>
          <el-button type="primary" @click="add">添加</el-button>
          <el-button @click="goBack">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
export default {
  components: {
    Breadcrumb
  },
  data() {
    return {
      labelPosition: "left",
      productTypeOptions: [],
      salePersonInfo: {
        productTypeId: "",
        afterSalePersonId: "",
        loginName: "",
        loginPwd: "",
        realName: "",
        staffCode: "",
        linkPhone: ""
      },
      rules: {
        loginName: [
          {
            max: 25,
            message: "最多输入25个字符",
            trigger: "change"
          }
        ],
        loginPwd: [
          {
            max: 25,
            message: "最多输入25个字符",
            trigger: "change"
          }
        ],
        realName: [
          {
            max: 25,
            message: "最多输入25个字符",
            trigger: "change"
          }
        ],
        staffCode: [
          {
            max: 25,
            message: "最多输入25个字符",
            trigger: "change"
          }
        ],
        linkPhone: [
          {
            max: 25,
            message: "最多输入25个字符",
            trigger: "change"
          }
        ]
      }
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    add() {
      let _this = this;
      _this.$refs.salesPersonForm.validate(isPass => {
        if (isPass) {
          let param = {
            url: "/api/salePerson/saveSalePersonInfo",
            params: {
              productTypeId: _this.salePersonInfo.productTypeId,
              loginName: _this.salePersonInfo.loginName,
              loginPwd: _this.salePersonInfo.loginPwd,
              realName: _this.salePersonInfo.realName,
              staffCode: _this.salePersonInfo.staffCode,
              linkPhone: _this.salePersonInfo.linkPhone
            }
          };

          _this.$Api
            .post(param.url, param.params)
            .then(response => {
              if (response.status === 200) {
                _this.$message({
                  message: "售后人员信息添加成功",
                  type: "success"
                });
                this.$router.push({
                  name: "salesPersonIndex"
                });
              } else {
                _this.$message({
                  message: response.data.msg,
                  type: "error"
                });
              }
            })
            .catch(err => {});
        } else {
          _this.$message({
            message: "请完善售后人员信息!",
            type: "warning"
          });
        }
      });
    },
    getProductTypeList() {
      let _this = this;
      let param = {
        url: "/api/productType/getProductTypeList"
      };

      _this.$store.dispatch("getProductTypeList", param).then(() => {
        _this.productTypeOptions =
          _this.$store.state.productType.productTypeList;
      });
    }
  },
  created() {
    let _this = this;
    _this.getProductTypeList();
  }
};
</script>

<style lang="sass" scoped>
.add-form-item
  width: 700px
  display: flex
  .el-form-item
    width: 460px
  .validate
    height: 40px
    line-height: 40px
    font-size: 14px
    color: #E6A23C
</style>
